const prefersReducedMotion = (): boolean => typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches

const motionDuration = (duration: string): string => (prefersReducedMotion() ? '0ms' : duration)

export const DURATION = {
  fast: motionDuration('150ms'),
  base: motionDuration('200ms'),
  route: motionDuration('280ms'),
  modalShow: motionDuration('220ms'),
  modalHide: motionDuration('160ms'),
  drawerShow: motionDuration('280ms'),
  drawerHide: motionDuration('200ms')
} as const

export const EASING = {
  out: 'ease-out',
  pop: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
  modal: 'cubic-bezier(0, 0, 0.2, 1)',
  drawer: 'cubic-bezier(0.215, 0.610, 0.355, 1)'
} as const

export const MODAL_TRANSITION_OPTIONS = `${DURATION.modalShow} ${EASING.modal}`

export const DRAWER_TRANSITION_OPTIONS = `${DURATION.drawerShow} ${EASING.drawer}`
